import { gql, TypedDocumentNode } from '@apollo/client'

import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { Data, Variables } from './types'

export const GET_DOMAIN_PREBID_MODULES: TypedDocumentNode<Data, Variables> = gql`
  ${ALERT_FRAGMENT}

  query domainPrebidModules(
    $domainId: ID!
    $moduleType: PrebidModuleTypeEnum
    $sort: DomainPrebidModuleSortInput
  ) {
    domainPrebidModules(domainId: $domainId, moduleType: $moduleType, sort: $sort) {
      nodes {
        id
        createdAt
        enabled
        fieldAlerts {
          ...AlertFragment
        }
        prebidModule {
          id
          demand
          name
        }
        updatedAt
        workspacePrebidModule {
          id
        }
      }
    }
  }
`
